/** Native names + flags — display order for language picker (not translated per UI language) */
export const LANGUAGE_OPTIONS = [
  { code: 'ko', flag: '🇰🇷', nativeLabel: '한국어' },
  { code: 'en', flag: '🇺🇸', nativeLabel: 'English' },
  { code: 'vi', flag: '🇻🇳', nativeLabel: 'Tiếng Việt' },
  { code: 'ru', flag: '🇷🇺', nativeLabel: 'Русский' },
  { code: 'ja', flag: '🇯🇵', nativeLabel: '日本語' },
  { code: 'zh-CN', flag: '🇨🇳', nativeLabel: '简体中文' },
  { code: 'th', flag: '🇹🇭', nativeLabel: 'ไทย' },
  { code: 'id', flag: '🇮🇩', nativeLabel: 'Bahasa Indonesia' },
  { code: 'hi', flag: '🇮🇳', nativeLabel: 'हिन्दी' },
  { code: 'zh-TW', flag: '🇹🇼', nativeLabel: '繁體中文' },
  { code: 'ar', flag: '🇸🇦', nativeLabel: 'العربية' },
  { code: 'fr', flag: '🇫🇷', nativeLabel: 'Français' },
  { code: 'de', flag: '🇩🇪', nativeLabel: 'Deutsch' },
  { code: 'es', flag: '🇪🇸', nativeLabel: 'Español' },
  { code: 'pt', flag: '🇧🇷', nativeLabel: 'Português' },
  { code: 'it', flag: '🇮🇹', nativeLabel: 'Italiano' },
  { code: 'nl', flag: '🇳🇱', nativeLabel: 'Nederlands' },
  { code: 'pl', flag: '🇵🇱', nativeLabel: 'Polski' },
  { code: 'tr', flag: '🇹🇷', nativeLabel: 'Türkçe' },
  { code: 'uk', flag: '🇺🇦', nativeLabel: 'Українська' },
  { code: 'mn', flag: '🇲🇳', nativeLabel: 'Монгол' },
  { code: 'kk', flag: '🇰🇿', nativeLabel: 'Қазақша' },
  { code: 'uz', flag: '🇺🇿', nativeLabel: 'Oʻzbekcha' },
  { code: 'ky', flag: '🇰🇬', nativeLabel: 'Кыргызча' },
  { code: 'ms', flag: '🇲🇾', nativeLabel: 'Bahasa Melayu' },
  { code: 'fil', flag: '🇵🇭', nativeLabel: 'Filipino' },
  { code: 'km', flag: '🇰🇭', nativeLabel: 'ខ្មែរ' },
  { code: 'my', flag: '🇲🇲', nativeLabel: 'မြန်မာဘာသာ' },
  { code: 'lo', flag: '🇱🇦', nativeLabel: 'ລາວ' },
  { code: 'ne', flag: '🇳🇵', nativeLabel: 'नेपाली' },
  { code: 'si', flag: '🇱🇰', nativeLabel: 'සිංහල' },
  { code: 'bn', flag: '🇧🇩', nativeLabel: 'বাংলা' },
  { code: 'ur', flag: '🇵🇰', nativeLabel: 'اردو' },
  { code: 'sw', flag: '🇰🇪', nativeLabel: 'Kiswahili' },
];

export function getLanguageOption(code) {
  return LANGUAGE_OPTIONS.find((o) => o.code === code) || LANGUAGE_OPTIONS[0];
}
